import React from 'react';
import { LuX } from 'react-icons/lu';

import { Strategy } from '@ndvr/portfolio-api';

import { WeightInput } from '@/components/ui/WeightInput';

interface StrategyAllocationItemProps {
    strategy?: Strategy;
    strategyAllocation: {
        strategyGUID: string;
        weight: string;
    };
    onUpdateWeight: (strategyGUID: string, weight: string) => void;
    onRemove: (strategyGUID: string) => void;
    error?: { message?: string };
}

export function StrategyAllocationItem({
    strategy,
    strategyAllocation,
    onUpdateWeight,
    onRemove,
    error,
}: StrategyAllocationItemProps) {
    return (
        <div className="border-border flex items-center justify-between rounded-lg border p-3">
            <div className="flex items-center gap-3">
                <span className="font-medium">{strategy?.strategyName || 'Unknown Strategy'}</span>
            </div>
            <div className="mr-4 flex items-center gap-6">
                <WeightInput
                    label="Target"
                    value={strategyAllocation.weight}
                    onChange={(value) => onUpdateWeight(strategyAllocation.strategyGUID, value)}
                    error={!!error}
                    errorMessage={error?.message}
                />
                <div
                    role="button"
                    tabIndex={0}
                    onClick={() => onRemove(strategyAllocation.strategyGUID)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            onRemove(strategyAllocation.strategyGUID);
                        }
                    }}
                    className="cursor-pointer text-gray-400 hover:text-gray-600"
                >
                    <LuX className="h-4 w-4" />
                </div>
            </div>
        </div>
    );
}
